import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'termFilter'
})
export class FilterTermPipe implements PipeTransform {
  transform(value: any, termItem: string, attrValue: string): any {
    let checkTerm: any;
    return termItem ?
    value.filter(objectList => {
    let someArray = attrValue.split('.');
    for (let entry of someArray) {
        objectList = objectList[entry];
    }
    checkTerm = termItem;
    if (termItem.toString() === 'true') { checkTerm = true; }
    if (termItem.toString() === 'false') { checkTerm = false; }
    return objectList === checkTerm; })
    : value;
  }
}
